import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const rootEl = document.getElementById('root');
    rootEl?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
